/**
 * Calculates the total weight based on predefined weight ranges
 * @param {number} weight - The input weight to calculate the range for
 * @returns {number} The calculated weight range
 */
export const calculateTotalWeight = weight => {
    let totalWeight = 0;
    if (weight <= 50) {
        totalWeight = 50;
    } else if (weight <= 100) {
        totalWeight = 100;
    } else if (weight <= 200) {
        totalWeight = 200;
    } else if (weight <= 300) {
        totalWeight = 300;
    } else if (weight <= 400) {
        totalWeight = 400;
    } else if (weight <= 500) {
        totalWeight = 500;
    } else if (weight <= 1000) {
        totalWeight = 1000;
    } else if (weight <= 2000) {
        totalWeight = 1500;
    } else if (weight <= 3000) {
        totalWeight = 2500;
    } else if (weight <= 4000) {
        totalWeight = 3500;
    } else if (weight <= 5000) {
        totalWeight = 4500;
    } else if (weight <= 7500) {
        totalWeight = 6250;
    } else if (weight <= 10000) {
        totalWeight = 8750;
    } else if (weight <= 12500) {
        totalWeight = 11250;
    } else if (weight <= 15000) {
        totalWeight = 13750;
    } else if (weight <= 17500) {
        totalWeight = 16250;
    } else if (weight <= 20000) {
        totalWeight = 18750;
    } else if (weight <= 45000) {
        totalWeight = 32500;
    } else {
        totalWeight = 45000;
    }
    return totalWeight;
};
